<template>
  <div>
  </div>
</template>

<script>
export default {
  name:"",
  components: {},
  props: {},
  data() {
	return {
	};
  },
  created() {},
  mounted() {
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {

  },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>

</style>
